import React, { useState } from 'react';
import JoeMarker from './JoeMarker';

type Size = 'sm' | 'md' | 'lg';

const DIMS: Record<Size, { w: number; h: number; band: number; joeH: number; topFs: number; sw: number }> = {
  sm: { w: 240, h: 140, band: 34, joeH: 78, topFs: 14, sw: 12 },
  md: { w: 340, h: 200, band: 48, joeH: 116, topFs: 18, sw: 18 },
  lg: { w: 440, h: 260, band: 60, joeH: 148, topFs: 22, sw: 22 },
};

interface NametagStickerProps {
  size?: Size;
  autoplay?: boolean;
  markerColor?: string;
}

export default function NametagSticker({
  size = 'md',
  autoplay = true,
  markerColor = 'var(--text)',
}: NametagStickerProps) {
  const [seed, setSeed] = useState(autoplay ? 0 : -1);
  const dims = DIMS[size];

  return (
    <button
      type="button"
      onClick={() => setSeed(s => s + 1)}
      title="click to replay"
      aria-label="Replay Joe signature animation"
      style={{
        width: dims.w,
        height: dims.h,
        cursor: 'pointer',
        position: 'relative',
        userSelect: 'none',
        borderRadius: 14,
        background: 'var(--bg-elev)',
        border: '3px solid var(--accent)',
        boxShadow:
          '0 10px 32px color-mix(in srgb, var(--accent) 18%, transparent), 0 1px 0 rgba(255,255,255,0.05) inset',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        padding: 0,
      }}
    >
      <div
        style={{
          height: dims.band,
          background: 'var(--accent)',
          borderBottom: '1px solid var(--accent-alt)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative',
        }}
      >
        <span
          style={{
            color: 'var(--accent-ink)',
            fontFamily: 'Inter, system-ui, sans-serif',
            fontSize: dims.topFs,
            fontWeight: 600,
            letterSpacing: 0.2,
          }}
        >
          Hi! I'm
        </span>
        <span
          style={{
            position: 'absolute',
            left: 14,
            top: '50%',
            transform: 'translateY(-50%)',
            width: 8,
            height: 8,
            borderRadius: '50%',
            background: 'rgba(0,0,0,.35)',
          }}
        />
        <span
          style={{
            position: 'absolute',
            right: 14,
            top: '50%',
            transform: 'translateY(-50%)',
            width: 8,
            height: 8,
            borderRadius: '50%',
            background: 'rgba(0,0,0,.35)',
          }}
        />
      </div>
      <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
        <div style={{ width: '82%', height: dims.joeH }}>
          <JoeMarker color={markerColor} strokeWidth={dims.sw} seed={seed} />
        </div>
      </div>
    </button>
  );
}
